<template>
    <div class="hide">{{isLoggedIn}}</div>
  <div class="chatroom" style="height:100vh" v-if="nowRoom">
    <section class="header">
      <chat-room-header :room_id="room_id" @chatroom-info="getRoomInfo" />
    </section>

    <section class="body" v-if="chatroomInfo">

      <div class="chat">
        <div class="subtitle">{{ chatroomInfo.subtitle }}</div>
        <chat-base
          :chat_roomId="chatroomid"
          :roomout="outsignal"
          @update-userlist="updateuserlist"
          :owner_userId ="chatroomInfo.user_id"   
          :chat_clear="chatClear"      
        ></chat-base>
      </div>

      <div class="aside">
        <div class="myInfo">
          <div class="top">
            <h3>내정보</h3>
          </div>
          <div class="cont">
               <user-name-tag
                :user="currentuser"
                :displaymytalk="true"
                :displayProfileImage="true"
                :ownerId ="chatroomInfo.user_id"
                />
          </div>
        </div>
        <div class="list-wrapper">
          <ul>

            <li class="item " id="room-info">
              <a href="javascript:void(0)" class="btn" @click="arrowtg('room-info')">
                <div class="top" >
                  <div class="title">채팅방정보</div>
                  <!-- <div class="cnt">
                    <span></span>
                  </div> -->
                  <div class="arrow">
                    <font-awesome-icon icon="angle-up" v-if="nowview.roominfo" class="roominfo"/>
                    <font-awesome-icon icon="angle-down" v-else />
                  </div>
                </div>
              </a>
              <div class="subMenu">
                <div class="user-list">
                    <div class="bd">
                        <div class="bd-tab" @click="managerViewToggle">방장 및 매니저</div>
                        <!--방장-->
                        <div class="owner" v-if="managerView">
                            <user-name-tag
                                :user="chatroomInfo.user"
                                :displaymytalk="false"
                                :displayProfileImage="true"
                                :ownerId ="chatroomInfo.user_id"
                                :owner="true"
                                />
                        </div>
                        <!-- 매니져 -->
                        <div v-if="chatroomInfo.manager.length > 0 && managerView" >
                            <template v-for="(manager, index) in chatroomInfo.manager" :key="index">
                                <div class="manager">
                                <user-name-tag
                                :user="manager.user"
                                :displaymytalk="false"
                                :displayProfileImage="true"
                                :roominfo ="chatroomInfo"
                                :manager="true"
                                :managerInfo="chatroomInfo.manager"
                                />
                                </div>
                            </template>
                        </div>
                    </div>
                    
                    <!--방장 및 매니져 메뉴 -->
                    <div class="room_control" v-if="isOwner || isManager || user.role==='admin'">
                      <div class="title">관리메뉴</div>
                      <ul>
                        <li @click="ChatClear()">채팅 지우기</li>
                      </ul>                     
                    </div>
                   
                    <!--방장만 보여줌-->
                    <div class="bd" v-if="chatroomInfo.ban.length > 0 && isOwner">
                        <div class="bd-tab ban-tab" @click="banUserToggle">강퇴유저</div>                       
                        <div v-if="banUserView">
                            <template v-for="(banuser, index) in chatroomInfo.ban" :key="index">
                                <div class="banuser">
                                    <user-name-tag
                                    :user="banuser.user"
                                    :displaymytalk="false"
                                    :displayProfileImage="true"
                                    :roominfo ="chatroomInfo"                                  
                                    />
                                </div>
                            </template>
                        </div>
                    </div>

                </div>
              </div>
            </li>

            <li class="item active" id="user-list">
              <a href="javascript:void(0)" class="btn" @click="arrowtg('user-list')">
                <div class="top" >
                  <div class="title">참여자목록</div>
                  <div class="cnt">
                    <span>{{connectusers.length}}</span>
                  </div>
                  <div class="arrow">
                    <font-awesome-icon icon="angle-up" v-if="nowview.userlist" class="userlist"/>
                    <font-awesome-icon icon="angle-down" v-else />
                  </div>
                </div>
              </a>
              <div class="subMenu">               
                
                <div class="connect-list">
                    <template v-for="(user, index) in connectusers" :key="index">
                        <user-name-tag
                        :user="user"
                        :displaymytalk="false"
                        :displayProfileImage="true"
                        :roominfo ="chatroomInfo"
                        :managerInfo="chatroomInfo.manager"                        
                        />
                    </template>
                </div>

              </div>
             
            </li>

            <li class="item" id="friend-list">
              <a href="javascript:void(0)" class="btn" @click="arrowtg('friend-list')">
                <div class="top" >
                  <div class="title">친구 목록</div>
                  <div class="arrow">
                    <font-awesome-icon icon="angle-up" v-if="nowview.friendlist" />
                    <font-awesome-icon icon="angle-down" v-else />
                  </div>
                </div>
              </a>
              <div class="subMenu">
                <div class="user-list"></div>
              </div>
            </li>

            <li class="roomexit">
                <a href="javascript:void(0)" @click="roomExit"> 채팅방 나가기</a>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="footer">
      <copyright />
    </section>
  </div>
</template>

<script>
import ChatBase from "@/components/chat/ChatBase.vue";
import ChatRoomHeader from "@/components/chat/parts/ChatRoomHeader";
import io from "socket.io-client";
import { removeClass } from '@/utils/selector.js';
import { auth } from '@/components/mixins/auth.js';
export default {
  name: "ChatRoom",
  props: ["room_id"],
  components: {
    ChatBase,
    ChatRoomHeader,
  },
  data() {
    return {
      chatroom: "",
      chatroomid: "",
      chatroomInfo: "",
      outsignal: "",
      nowview:{
          state:'userlist',
          userlist:true,
          roominfo:false,
          friendlist:false
      },
      nowRoom:true,// 방생성후 라우터 2중으로 표시되는 문제
      connectusers:[],
      managerView:true,
      banUserView:true,      
      socket: io(this.$store.state.serverDomain + ":3000"),
    };
  },
  mixins:[
    auth
  ],
  computed:{
    isLoggedIn() {
        if(this.$store.getters.isAuthenticated)
        {                  
            return true;
        }else{
            //로그아웃이면 채팅창을 닫는다.
            alert('로그아웃되었습니다.');
            window.close();
            return false
        }      
    },
    isOwner()
    {
      if(this.chatroomInfo){
          return this.currentuser.id === this.chatroomInfo.user_id;
      }else{
          return false;
      }        
    },
    isManager(){
      if(this.chatroomInfo && this.chatroomInfo.manager.find((manager)=>manager.user_id === this.currentuser.id))
      {
        return true;
      }else{
        return false;
      }
    }
  },
  created() {
    this.chatroomid = "room_" + this.room_id;
    this.currentuser = this.$store.getters.currentUser;
  },
  methods: {   
    ChatClear(){
      //채팅내용 지우기, 방장과 매니저만 사용
      let request = '방장';
      if(this.isManager){request ='매니저';}
       if(this.user.role==='admin'){request ='관리자';}
      let params = {
        room_id:this.chatroomid,
        who: request
      }
      this.socket.emit("DeleteMessage", params, function (callback) {
                    console.log(callback);
                });
    },
    updateuserlist(users)
    {
      this.connectusers = users;
      console.log("접속유저",this.connectusers);
    },
    
    managerViewToggle(){
      this.managerView = !this.managerView
    },
    banUserToggle(){
      this.banUserView = !this.banUserView
    },
    arrowtg(now){
        console.log(now)
        //document.querySelectorAll('[data-icon="angle-up"]').remove()//.classList.add('hide');

        if(this.nowview.state !== now)
        {
            this.nowview.userlist = false;
            this.nowview.roominfo = false;
            this.nowview.friendlist = false;

            if(now ==="user-list") this.nowview.userlist = true;
            if(now ==="room-info") this.nowview.roominfo = true;
            if(now ==="friend-list") this.nowview.friendlist = true;

            this.nowview.state = now;
            removeClass('.item','active');
            let element = document.querySelector('#'+now);
            element.classList.add('active');

        }
    },
    getRoomInfo(data) {
      //console.log('ChatRoom에서 데이터',data);
      this.chatroomInfo = data;
    },
    roomExit() {
      //alert(this.room_id);
      this.outsignal = this.room_id;
      //this.nowRoom=false;
      this.$router.push("/chat/lobby"); //accordian 작동이 안된다.

      //this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/aside';
.chatroom {
  font-family: gulim, dotum;

  .body {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    height: calc(100vh - 65px);
    .chat {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      .subtitle {
        border-top: 1px solid #e5dfbd;
        background-color: #fff8d3;
        text-overflow: ellipsis;
        font-size: 11px;
        color: #a39e86;
        line-height: 28px;
        padding-left: 45px;
      }
    }
    .userInfo {
      flex-basis: 440px;
    }

    .aside{
        .active{
            a{color:#000;font-weight:bold}
            .subMenu{
              max-height:calc(100vh - 246px);
              height:calc(100vh - 246px);
              overflow-y: auto;
            }
        }
        .roomexit{
            font-size:11px;
            padding-left:10px;
            line-height:25px;
            background:#000;
            a{color:yellow;}
        }
    }
  }
  .footer {
    background-color: #39302d;
    font-size: 10px;
    color: #777371;
    font-family: Arial, Helvetica, sans-serif;
    line-height: 20px;
  }
}
</style>
